import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button } from "antd";
import { Link } from "react-router-dom";
import styles from "./Accessibilitat.module.css";
import htmlContent from "../static/accessibilitat/accessibilitat.html";
import { setTitolApartat } from "../actions";
import { getUsuari } from "../reducers";
import { TITOL_ACCESSIBILITAT } from "../constantsFormularis";
import { rutaLogin } from "../routes";
import { calFerLogin } from "../utils/usuariRols";

const generarBotoTornar = () => {
  return (
    <Link
      to={{
        pathname: rutaLogin,
        query: { render: false }
      }}
    >
      <Button icon="left">Tornar</Button>
    </Link>
  );
};

const getHTML = usuari => (
  <div>
    <div
      className={styles.accessibilitat}
      dangerouslySetInnerHTML={{
        __html: htmlContent
      }}
    />
    {!calFerLogin(usuari) ? null : generarBotoTornar()}
  </div>
);

class Accessibilitat extends React.Component {
  componentDidMount() {
    this.props.setTitolApartat(TITOL_ACCESSIBILITAT);
  }

  render() {
    return getHTML(this.props.usuari);
  }
}

Accessibilitat.propTypes = {
  setTitolApartat: PropTypes.func.isRequired
};

Accessibilitat.propTypes = {
  usuari: PropTypes.object
};

const mapStateToProps = state => {
  return {
    usuari: getUsuari(state)
  };
};

export default connect(mapStateToProps, {
  setTitolApartat
})(Accessibilitat);
